var map = {
	"./StarsShades1colorred.avif": 1369,
	"./StarsShades2colorpurple.avif": 2119,
	"./StarsShades3colorgreen.avif": 5327,
	"./StarsShades4colorpink.avif": 183,
	"./StarsShades5colororange.avif": 4704,
	"./StarsShades6colorblue.avif": 9117
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7666;